import { render, staticRenderFns } from "./AcoesDespublicar.vue?vue&type=template&id=65dcb956&scoped=true"
import script from "./AcoesDespublicar.vue?vue&type=script&lang=js"
export * from "./AcoesDespublicar.vue?vue&type=script&lang=js"
import style0 from "./AcoesDespublicar.vue?vue&type=style&index=0&id=65dcb956&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dcb956",
  null
  
)

export default component.exports